const state = {
  services: [],
  services_selected: [],
}

export const customEditorRequiredFields = [
  { key: 'editor.services' },
]

export default state
